import * as Actions from '../actions';

const initialState = {
    supervisi : {
        rows: [],
        results: 0
    },
    supervisi_pengawas_lain : {
        rows: [],
        results: 0
    },
    pengawas : {
        rows: [{
            nama: null
        }],
        results: 0
    }
};

const supervisiReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_SUPERVISI:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                supervisi: action.payload
            };
        }
        case Actions.GET_SUPERVISI_PENGAWAS_LAIN:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                supervisi_pengawas_lain: action.payload
            };
        }
        case Actions.GET_PENGAWAS:
        {
            return {
                ...state,
                routeParams: action.routeParams,
                pengawas: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
}

export default supervisiReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/Supervisi.reducers.js